import { collection, doc, getDoc, where } from "@firebase/firestore";
import { db } from "../../../firebase";

const GetSingleResult = async (ResultID) => {
  try {
    const ResultsCollection = collection(db, "Results");
    const ResultDocument = doc(ResultsCollection, ResultID);
    const ResultSnapshot = await getDoc(
      ResultDocument,
      where("IsDeleted", "==", false)
    );

    let Result = { ...ResultSnapshot.data(), id: ResultSnapshot.id };

    return Result;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleResult;
